exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".el-form-item__label[data-v-5bfabd82]{padding:0!important}.sign-up-form .el-form-item[data-v-5bfabd82]{margin-bottom:12px}.sign-up-form .el-form-item .el-form-item__label[data-v-5bfabd82]{padding:0!important}", ""]);

// exports
